const validate = (values) => {
  const errors = {};

  if (!values.insuranceType || values.insuranceType.trim() === '') {
    errors.insuranceType = 'Please enter insurance type';
  }
  if (!values.insuranceCode || values.insuranceCode.trim() === '') {
    errors.insuranceCode = 'Please enter insurance code';
  }
  // if (!values.Description) {
  //   errors.Description = 'Please enter Description';
  // }
  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/insurance-master/validate.js